import { isTargetApp } from '../../CBP_App/api/util';
import { getQueryVariable } from '../../apiCalls/jobInfo';

//  Extracts shipment ID from various data structures
export const extractShipmentId = (data) => {
  if (!data) return null;
  
  if (data.shipmentId) return data.shipmentId;
  if (data.shipmentID) return data.shipmentID;
  
  if (data.brokerJobs?.currentBrokerJobs?.[0]?.shipmentId) {
    return data.brokerJobs.currentBrokerJobs[0].shipmentId;
  }
  
  return null;
};

//  Checks if a shipment ID matches the data (checks multiple locations)
export const matchesShipmentId = (shipmentId, data) => {
  if (!shipmentId || !data) return false;
  
  const shipmentIdInData = extractShipmentId(data);
  const entryIds = data.entryIds || [];
  
  return entryIds.includes(shipmentId) || shipmentIdInData === shipmentId;
};

// ============================================================================
// ENTRY STATUS EVENTS
// ============================================================================
export const ENTRY_STATUS_EVENTS = {
  GET_ENTRY_STATUS: 'GET_ENTRY_STATUS',
  GET_ENTRY_STATUS_RESPONSE: 'GET_ENTRY_STATUS_RESPONSE',
  GET_ENTRY_STATUS_ERROR: 'GET_ENTRY_STATUS_ERROR',
  DISCONNECT: 'DISCONNECT', // Event to stop monitoring a shipment
};

// ============================================================================
// BROKER SHIPMENT SEARCH EVENTS
// ============================================================================
export const BROKER_SHIPMENT_EVENTS = {
  SEARCH_BROKER_SHIPMENT: 'SEARCH_SHIPMENTS_BROKER',
  SEARCH_BROKER_SHIPMENT_RESPONSE: 'SEARCH_SHIPMENTS_BROKER_RESPONSE',
  DISCONNECT: 'SEARCH_SHIPMENTS_BROKER_DISCONNECT',
};

//  Gets WebSocket URL based on environment
export const getWebSocketUrl = () => {
  console.log('getWebSocketUrl', window._env_?.REACT_APP_WEBSOCKET_URL)
  if (typeof window !== 'undefined' && window._env_?.REACT_APP_WEBSOCKET_URL) {
    return window._env_.REACT_APP_WEBSOCKET_URL;
  }

  if (typeof window === 'undefined') return null;

  const hostname = window.location.hostname.toLowerCase();
  const isLocal = hostname.includes('localhost') || hostname.includes('127.0.0.1');

  const envMap = {
    dev: 'wss://websocket-api.dev.klearnow.com/ws',
    qat: 'wss://websocket-api.qat.klearnow.com/ws',
    stage: 'wss://websocket-api.stage.klearnow.com/ws',
    prod: 'wss://websocket-api.klearnow.com/ws'
  };

  if (hostname.includes('dev') || hostname.includes('development')) return envMap.dev;
  if (hostname.includes('qat') || hostname.includes('qa')) return envMap.qat;
  if (hostname.includes('stage') || hostname.includes('staging') || isLocal) return envMap.stage;
  return envMap.prod;
};

// ============================================================================
// SOCKET USAGE UTILITIES
// ============================================================================

// Checks if socket is enabled for current environment
export const isSocketEnabled = () => {
  // For now, return true by default to enable socket
  // TODO: Uncomment below code when environment-based control is needed
  return true;
  
  // Future implementation - keep for future use:
  // if (typeof window === 'undefined' || !window._env_?.REACT_APP_BROKER_API_URL) {
  //   return false;
  // }
  //
  // const envUrl = window._env_.REACT_APP_BROKER_API_URL.toLowerCase();
  // 
  // // List of environments where socket should be enabled (use includes to check)
  // const enabledEnvs = ['dev', 'qat', 'stage', 'prod']; // Add/remove environments as needed
  // 
  // return enabledEnvs.some(env => envUrl.includes(env));
};

// Checks if socket should be used for engine shipments
export const shouldUseSocketForEngineShipment = () => {
  // First check if socket is enabled for this environment
  if (!isSocketEnabled()) {
    return false;
  }
  
  // if (isTargetApp()) {
  //   return false;
  // }
  const ENTRY_STATUS_SOCKET_SUPPORTED_COUNTRIES = ['US'];
  const shipmentCountry = getQueryVariable('transactionCountry') || (typeof window !== 'undefined' ? window.shipmentCountry : null) || 'US';
  return ENTRY_STATUS_SOCKET_SUPPORTED_COUNTRIES.includes(shipmentCountry.toUpperCase());
};

// Checks if HTTP polling should be used instead of socket
export const shouldUseHttpPolling = (socketClient = null) => {
  // If socket is disabled for this environment, always use HTTP polling
  if (!isSocketEnabled()) {
    return true;
  }

  let client = socketClient;
  if (!client && typeof window !== 'undefined') {
    try {
      const { getSocketClient } = require('./index');
      client = getSocketClient();
    } catch (e) {
      client = null;
    }
  }
  if (!client || !client.isConnected()) {
    return true;
  }
  return !shouldUseSocketForEngineShipment();
};

